<template>
  <div class="w-full">
    <div>
      <vs-row vs-w="12" vs-align="flex-start" vs-justify="center">
        <vs-col vs-w="6" vs-align="center" vs-justify="center">
          <div id="simple-calendar-app" class="mr-3">
            <div class="vx-card no-scroll-content">
              <calendar-view
                ref="calendar"
                :displayPeriodUom="calendarView"
                :show-date="showDate"
                :events="calendarEvents"
                :class="blockActions ? 'block-cursor' : 'cursor-pointer'"
                locale="pt-br"
                monthNameFormat="numeric"
                eventBorderHeight="0px"
                eventContentHeight="1.5rem"
                locale-pt
                class="theme-default"
                :starting-day-of-week="1"
                @click-date="select"
              >
                <div slot="header" class="mb-4">
                  <div class="vx-row no-gutter justify-between items-center w-full">
                    <div class="flex items-center">
                      <!-- Current Month -->
                      <div class="flex items-center mr-6">
                        <feather-icon
                          :icon="
                            $vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'
                          "
                          @click="updateMonth(-1)"
                          svgClasses="w-5 h-5 m-1"
                          class="cursor-pointer bg-primary text-white rounded-full flex-shrink-0"
                        />

                        <span
                          @click="isModalMonthYearActive = true"
                          class="mx-3 text-xl font-medium whitespace-no-wrap text-center cursor-pointer hover:text-primary"
                          style="min-width: 200px; display: inline-block;"
                        >
                          {{
                            meses[showDate.getMonth()] +
                            " - " +
                            showDate.getFullYear()
                          }}</span
                        >

                        <feather-icon
                          :icon="
                            $vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'
                          "
                          @click="updateMonth(1)"
                          svgClasses="w-5 h-5 m-1"
                          class="cursor-pointer bg-primary text-white rounded-full flex-shrink-0"
                        />
                      </div>

                      <div class="flex items-center">
                        <span class="mr-2 text-sm font-semibold">{{ mostrarHorasIniciais ? 'Horas Iniciais' : 'Manutenção' }}</span>
                        <vs-switch v-model="mostrarHorasIniciais" />
                      </div>
                    </div>

                    <div class="flex items-center justify-end">
                      <vs-button color="primary" type="border" icon="refresh" @click="fetchForcaMensal">Atualizar</vs-button>
                    </div>
                  </div>
                </div>
              </calendar-view>
            </div>
          </div>
        </vs-col>
        <vs-col vs-w="6" vs-align="center" vs-justify="center">
          <component
            v-bind:is="showCardForca"
            :key="reRenderCard"
            :data="dataForca"
            :forcaDataObj="forcaDataObjSelecionada"
          >
          </component>
        </vs-col>
      </vs-row>
      <ModalSelectMonthYear
        :active.sync="isModalMonthYearActive"
        :initial-month="showDate.getMonth()"
        :initial-year="showDate.getFullYear()"
        @selected="onMonthYearSelected"
      />
    </div>
  </div>
</template>

<script>
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
import moduleCalendar from "@/store/calendar/moduleCalendar.js"
import cardForca from "./cardForca.vue"
import ModalSelectMonthYear from "@/components/default/ModalSelectMonthYear.vue"

require("vue-simple-calendar/static/css/default.css")

import Datepicker from "vuejs-datepicker"

export default {
  props: {
    blockActions: { default: false },
  },
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    cardForca,
    ModalSelectMonthYear,
  },
  data () {
    return {
      showCardForca: null,
      reRenderCard: 0,
      showDate: new Date(),
      calendarView: "month",
      dataForca: this.$formartData.removeTimeZone(new Date()).split("T")[0],
      meses: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      mensalData: null,
      mostrarHorasIniciais: true,
      forcaDataObjSelecionada: null,
      isModalMonthYearActive: false,
    }
  },
  computed: {
    calendarEvents() {
      if (!this.mensalData) return [];
      let events = [];
      for (const [date, turnos] of Object.entries(this.mensalData)) {
        if (turnos === "feriado") {
          events.push({
            startDate: date,
            title: "FERIADO",
            classes: "event-feriado"
          });
          continue;
        }
        const turnosInteresse = {
          "Manha": "M",
          "Tarde": "T",
          "Noite": "N"
        };
        for (const turno of turnos) {
          if (turnosInteresse[turno.nome]) {
            let val = this.mostrarHorasIniciais ? turno.forcaInicial : turno.forca;
            let bgClass = val > 0 ? "event-positive" : "event-negative";
            events.push({
              startDate: date,
              title: `${turnosInteresse[turno.nome]} ${val}`,
              classes: bgClass
            });
          }
        }
      }
      return events;
    }
  },
  methods: {
    async select (d) {
      if (this.blockActions) {
        return
      }
      this.dataForca = await this.$formartData
        .removeTimeZone(d)
        .split("T")[0]
      this.$emit("data-selecionada", this.dataForca)
      this.updateForcaSelecionada()
      this.reRenderCard += 1
      return
    },

    async updateMonth (val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val)
      await this.fetchForcaMensal()
    },
    async onMonthYearSelected(data) {
      this.showDate = new Date(data.year, data.month, 1)
      await this.fetchForcaMensal()
    },
    async fetchForcaMensal() {
      let ano = this.showDate.getFullYear();
      let mes = this.showDate.getMonth() + 1;
      await this.$vs.loading({ container: "#simple-calendar-app", scale: 0.6 });
      try {
        this.mensalData = await this.$http.post("getForcaMensal", { ano, mes });
        this.updateForcaSelecionada();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/"); 
        };
      } finally {
        await this.$vs.loading.close("#simple-calendar-app > .con-vs-loading");
      }
    },
    updateForcaSelecionada() {
      if (this.mensalData && this.dataForca && this.mensalData[this.dataForca]) {
        this.forcaDataObjSelecionada = this.mensalData[this.dataForca];
      } else {
        this.forcaDataObjSelecionada = null;
      }
    },
  },
  async created () {
    this.$store.registerModule("calendar", moduleCalendar)
  },
  beforeDestroy () {
    this.$store.unregisterModule("calendar")
  },
  async mounted () {
    this.showCardForca = "cardForca"
    this.reRenderCard += 1
    await this.fetchForcaMensal()
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
.cv-weeks {
  min-height: 30rem !important;
}
.cv-week {
  min-height: 6rem !important;
}
.block-cursor {
  &:hover {
    color: lightgrey;
    cursor: not-allowed;
  }
}
.theme-default .cv-event {
  font-size: 0.70rem !important;
  border-radius: 0%;
  background-color: rgba(202, 202, 202, 0.233);
  color: black !important;
  width: fit-content !important;
  min-width: 36px;
  margin-left: 45px !important;
  margin-right: auto !important;
  pointer-events: none !important;
}
.theme-default .cv-event.event-positive {
  background-color: #d4edda !important;
  color: #155724 !important;
  border-radius: 6px !important;
  margin-bottom: 3px !important;
  text-align: center;
  font-weight: bold;
  padding: 2px 6px;
}
.theme-default .cv-event.event-negative {
  background-color: #f8d7da !important;
  color: #721c24 !important;
  border-radius: 6px !important;
  margin-bottom: 3px !important;
  text-align: center;
  font-weight: bold;
  padding: 2px 6px;
}
.theme-default .cv-event.event-feriado {
  background-color: transparent !important;
  color: #c0392b !important;
  border-radius: 0 !important;
  font-weight: bold !important;
  font-size: 0.75rem !important;
  text-align: left;
  margin-left: 40px !important;
  margin-right: auto !important;
  width: fit-content !important;
  box-shadow: none !important;
  border: none !important;
}
</style>
